/**
 * @architecture-header 1
 * @layer module
 * @domain live
 * @responsibility Count minutes since the live panel opened, which is what a snooze counts against.
 * @state-owner React state local to the caller
 * @allowed-imports React
 * @forbidden dataset stores; network; component markup
 * @public-api live module components
 * @side-effects one interval timer while mounted
 * @tests modules/live/store/seat-alerts.test.ts covers what consumes it
 */

import { useEffect, useState } from 'react';

/** Ticks once a minute: a snooze countdown does not need to be accurate to the second. */
export function useSessionMinutes(): number {
  const [minutes, setMinutes] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => setMinutes((value) => value + 1), 60_000);
    return () => window.clearInterval(timer);
  }, []);

  return minutes;
}
